// extracted by mini-css-extract-plugin
module.exports = {"video":"Video-module--video--dZvgO","isBuffering":"Video-module--isBuffering--2EF-y","flicker":"Video-module--flicker--1vS_P","nextVideo":"Video-module--nextVideo--3tS3Z"};